import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <nav className="footer-navigation" aria-label="Legal and regulatory">
          <ul className="footer-menu">
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/regulatory-details">Regulatory Details</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
          </ul>
        </nav>
        <div className="footer-info">
          YK2 Partners Private Limited is the Investment Manager for YK2 Partners India Equity Fund (Category III Alternative Investment Fund with Registration Number: IN/AIF3/23-24/1386)
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} YK2 Partners, Inc. All rights reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
